import axios from 'axios';
import { getRoutesQuery, getProcessorsQuery, getProducersQuery, getHaulingCompaniesQuery } from './queries';
import { arrayToMap, renameKey } from '../../utils';
import Split from '../split';
import { buildExpressQuery, buildLoopbackQuery } from './queries/builders';

const getRoutes = async (haulingId, routeId = null, filterDeletedProducers = false) => {
    const useExpressMigration = Split.getBooleanTreatment('use_express_migration_endpoints');
    const migrationQueryBuilder = useExpressMigration ? buildExpressQuery : buildLoopbackQuery;
    const useExpressAuth = Split.getBooleanTreatment('use_express_auth_endpoints');
    const authQueryBuilder = useExpressAuth ? buildExpressQuery : buildLoopbackQuery;
    if (!routeId) {
        try {
            const requests = [];

            const routeQuery = getRoutesQuery({ ...(!!haulingId && { haulingId }), filterDeleted: true, queryBuilder: migrationQueryBuilder });
            requests.push(axios.get(routeQuery));

            const haulersQuery = getHaulingCompaniesQuery({ fields: ['id', 'name'], queryBuilder: authQueryBuilder });
            requests.push(axios.get(haulersQuery));

            const processorsQuery = getProcessorsQuery({ fields: ['id', 'name'], queryBuilder: authQueryBuilder });
            requests.push(axios.get(processorsQuery));

            const producersQuery = getProducersQuery({ fields: ['id', 'name'], filterDeleted: filterDeletedProducers, queryBuilder: authQueryBuilder });
            requests.push(axios.get(producersQuery));

            const [routeResponse, haulersResponse, processorsResponse, producersResponse] = (await Promise.all(requests)).map((res) => res.data);
            if (useExpressMigration) {
                renameKey(routeResponse, '_id', 'id');
            }
            if (useExpressAuth) {
                renameKey(haulersResponse, '_id', 'id');
                renameKey(processorsResponse, '_id', 'id');
                renameKey(producersResponse, '_id', 'id');
            }

            const haulersMap = arrayToMap(haulersResponse, 'id');
            const processorsMap = arrayToMap(processorsResponse, 'id');
            const producersMap = arrayToMap(producersResponse, 'id');

            return routeResponse.map((result) => {
                return {
                    ...result,
                    hauling_companies_names: result.hauling_companies?.map((hId) => haulersMap[hId]?.name || null),
                    processor_names: result.processors?.map((id) => processorsMap[id]?.name || null),
                    producer_names: result.users?.map((id) => producersMap[id]?.name).filter((name) => name),
                };
            });
        } catch (err) {
            // eslint-disable-next-line
            console.log(err);
            throw new Error('Unable to process request.');
        }
    } else {
        try {
            const routeQuery = getRoutesQuery({ id: routeId, queryBuilder: migrationQueryBuilder });
            const routeResp = await axios.get(routeQuery);
            if (useExpressMigration) {
                renameKey(routeResp.data, '_id', 'id');
            }
            return routeResp.data;
        } catch (err) {
            // eslint-disable-next-line
            console.log(err);
            throw new Error('Unable to process request.');
        }
    }
};

export default getRoutes;
